







































































































































import {Component, Vue} from "vue-property-decorator";
import CrmHeader from "@/components/crmHeader/index.vue";
import {RouterModule} from "@/store/modules/router";
import {UserModule} from "@/store/modules/user";
import {
  getMyselfUser,
  getUserList,
  checkLogin,
} from "@/api/common";
import {wastchSokcet} from "@/utils/socket.io";
import {MessageModule} from "@/store/modules/message";
import { eventBus, EventType } from '@/utils/eventBus'
// 内存缓存
const userCache = {
  userInfo: null as any,
  userList: null as any,
  lastFetchTime: 0
};
@Component({
  components: {CrmHeader},
})
export default class App extends Vue {
  isCheckLogin = false; // 当前是否通过登录验证
  isDisable = false; // 显示h5
  type = ''
  approvalType = ''
  flagType = ''
  sortIndex = []

  get userId() {
    return UserModule.userId || "";
  }

  get msgNoticeData() {
    return MessageModule.resData
  }

  get msgList() {
    const arr = MessageModule.msgList

    for (const key in arr) {
      if (arr[key].length > 0) {
        this.sortIndex.push(key)
      } else {
        const index = this.sortIndex.indexOf(key)
        if (index !== -1) {
          this.sortIndex.splice(index, 1)
        }
      }
    }
    this.sortIndex = this.newArrFn(this.sortIndex)
    return MessageModule.msgList
  }

  getOriginMsgList() {
    return MessageModule.msgList
  }

  created() {
    const url = window.location.href
    if (url.indexOf("isH5") >= 0) { //判断url地址中是否包含isH5字符串
      this.isDisable = true
    } else {
      this.getCheckLogin();
    }
  }


  newArrFn(arr) {
    const newArr = []
    for (let i = 0; i < arr.length; i++) {
      newArr.indexOf(arr[i]) === -1 ? newArr.push(arr[i]) : newArr
    }

    return newArr
  }

  async getCheckLogin() {
     const data = await checkLogin()
    if (!data) {
      let href = ''
      if (process.env.NODE_ENV === 'development') {
        href = 'http://192.168.0.138:8080/login'
      } else {
        if (origin.indexOf('-testserver') === -1) {
          href = 'https://center.gecacademy.cn/home'
        } else {
          href = 'https://center-testserver.gecacademy.cn/home'
        }
      }
      window.location.href = href
    } else {
      this.isCheckLogin = true
      await this.getUserInfo()
      // await this.getUserList()
      // await MessageModule.getMessageCount()
    }
  }

  async getUserInfo() {
     // 检查内存缓存
    if (userCache.userInfo) {
      UserModule.SET_USER_INFO(userCache.userInfo);
      return;
    }
    
    // 从服务器获取
    const data: any = await getMyselfUser();
    userCache.userInfo = data;
    UserModule.SET_USER_INFO(data);
    // 触发用户信息更新事件
    eventBus.$emit(EventType.USER_INFO_UPDATED, data);
  }

  async getUserList() {
    // 检查内存缓存
    if (userCache.userList) {
      UserModule.SET_USER_LIST(userCache.userList);
      return;
    }
    
    // 从服务器获取
    const data: any = await getUserList();
    userCache.userList = data;
    UserModule.SET_USER_LIST(data);
  }

  closeMsg(name) {

    this.$store.commit('DELETE_MESG_ITEM', name)


  }

  // 查看
  viewMsg(types, approvalType) {
    if (types == 'messageReviewUser') {
      //  审批
      this.openPage('/message/approval?approvalType=' + approvalType);
    } else if (types == 'remind') {
      // 提醒
      this.openPage('/message/remind');
    } else if (types == 'Notice') {
      //  通知
      this.openPage('/message/notice');
    } else if (types == 'messageReviewCc') {
      //抄送
      this.openPage('/message/approval?approvalType=' + approvalType);
    }
    this.$store.commit('DELETE_MESG_ITEM', types)
  }

  openPage(url: string) {
    const win = window.open(window.location.origin + url, '_blank')

    const time = setInterval(() => {
      if (win.closed) {
        clearInterval(time)
      }
    }, 500)
  }


  initRouter() {
    RouterModule.initRouter1();
  }

  initSocket() {
    const time = setInterval(() => {
      if (Vue.prototype.$socket.on) {
        wastchSokcet(this.userId).then((res: any) => {

          const types = res.types
          if (types === 'remind') {
            this.type = '提醒'
          } else if (types === 'messageReviewUser') {
            this.type = '审批'
            this.approvalType = '0'
          } else if (types === 'messageReviewCc') {
            this.type = '抄送'
            this.approvalType = '2'
          }
          res.types = this.type
          this.$store.commit('GETMSGLIST', res)


        });

        clearInterval(time)
      }
    }, 100)
  }


}
